import React from 'react';
import PropTypes from 'prop-types';

/**
 * Generate the Administrative Dashboard button
 *
 */
const MyAdministratorTools = props => {
	const { analyticsUrl } = props;

	const clickHandler = () => {
		window.location.href = analyticsUrl;
	};

	return (
		<div className={'my-administrator-tools'}>
			<div className={'product-wrapper row'}>
				<div className={'my-products col-11 col-offset-1'}>
					<h3 className={'title-line artz'}>My administrator tools</h3>
					<button
						onClick={clickHandler}
						className={'btn btn-primary btn btn-primary'}
					>Go to Administrative Dashboard</button>
				</div>
			</div>
		</div>
	);
};

MyAdministratorTools.propTypes = {
	analyticsUrl: PropTypes.string
};

export default MyAdministratorTools;
